import styled from "styled-components";

type ColorProps = { color: string };
type BackgroundProps = { background: string };
type BorderProps = { borderColor: string };

export const TableRow = styled.tr<BorderProps>`
    border-bottom: 1px solid ${props => props.borderColor};
    transition: background 0.15s;

    &:last-child {
        border-bottom: none;
    }
`;

export const TableCell = styled.td<ColorProps>`
    padding: 11px 12px;
    font-size: 13px;
    color: ${props => props.color};
    vertical-align: middle;

    &:last-child {
        text-align: right;
        font-weight: 600;
    }
`;

export const ItemCellContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const IconWrapper = styled.div<BackgroundProps & ColorProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: ${props => props.background};
    color: ${props => props.color};
    flex-shrink: 0;
`;

export const ItemLabel = styled.span<ColorProps>`
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.color};
`;
